import { TagCellItem } from './TagCell.props';

interface RawTag {
  text?: string;
  title?: string;
  colour?: string;
  color?: string;
  isSystem?: boolean;
}

/**
 * Normalises the tag shapes the BFF returns into TagCell's input. List
 * endpoints aggregate tags into a JSON *string* keyed `title`/`color`, while
 * detail endpoints return an array keyed `text`/`colour`. Anything else — a
 * plain string, malformed JSON, a nameless tag — yields no chips rather than
 * leaking a raw value into the cell.
 */
export const toTagCellItems = (value: unknown): TagCellItem[] => {
  let raw: unknown = value;

  if (typeof value === 'string') {
    try {
      raw = JSON.parse(value);
    } catch {
      return [];
    }
  }

  if (!Array.isArray(raw)) return [];

  return raw
    .map((tag: RawTag) => ({
      title: tag?.title ?? tag?.text ?? '',
      color: tag?.color ?? tag?.colour ?? '',
      isSystem: Boolean(tag?.isSystem),
    }))
    .filter((tag) => tag.title !== '');
};
